import { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar/AppBar';
import { CSSObject, styled, Theme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import {
    ACTIVITYTILIST,
    CASEMANAGEMENTLIST,
    CASEMANAGERBULKLOAD,
    CASEMANAGERLIST,
    CASEREPORT,
    ACTIVITYTIMESEXPORT,
    HOME,
    USERLIST,
    WECALLYOUADMIN,
    BLOCKPAGES,
    SURVEYLIST,
    CASECLOSURE,
    COMMERCIAL_CRM_LOAD_BASE_BP,
    COMMERCIAL_CRM_LOAD_BASE_GUPSHUP,
    COMMERCIAL_CRM_LOAD_BASE_GUPSHUP_CUSTOM,
    CASECREATION,
    CASEOTRS,
    TEMPLATES_WSP,
    USERSCREATION,
    VOICE_BLASTER,
    IVR,
    IVR_TYPIFICATION_BASE,
} from '../../../routes/paths';
import { MasterMessage } from '../../../masters/masterMessages';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CasesOutlinedIcon from '@mui/icons-material/CasesOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import PhoneCallbackOutlinedIcon from '@mui/icons-material/PhoneCallbackOutlined';
import AddToQueueOutlinedIcon from '@mui/icons-material/AddToQueueOutlined';
import AppBlockingOutlinedIcon from '@mui/icons-material/AppBlockingOutlined';
import SubtitlesOutlinedIcon from '@mui/icons-material/SubtitlesOutlined';
import WorkOffOutlinedIcon from '@mui/icons-material/WorkOffOutlined';
import FingerprintOutlinedIcon from '@mui/icons-material/FingerprintOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import EscalatorIcon from '@mui/icons-material/Escalator';
import CampaignIcon from '@mui/icons-material/Campaign';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

export const drawerWidth = 230;

export const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
});

export const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(9)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(10)} + 1px)`,
    },
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
});

export const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

export const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
    }),
}));

export const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const {
    home,
    bulkLoad,
    cases,
    times,
    caseManagement,
    caseManager,
    caseClosure,
    caseCreation,
    caseOTRS,
    activityTimes,
    surveys,
    users,
    exportActivityTimes,
    weCallYouAdmin,
    caseReport,
    blokPages,
    commercialCrm,
    commercialCrmLoadBaseBP,
    commercialCrmLoadBaseGupshup,
    commercialCrmLoadBaseGupshupCustom,
    wspTemplates,
    usersCreation,
    voiceBlaster,
    ivr,
    ivrTypificationBase,
} = MasterMessage.modules;

export const ModulesSideBar = [
    {
        route: HOME,
        label: home,
        icon: <HomeOutlinedIcon color="secondary" />,
    },
    {
        route: TEMPLATES_WSP,
        label: wspTemplates,
        icon: <WhatsAppIcon color="secondary" />,
    },
    {
        label: times,
        icon: <AccessTimeOutlinedIcon color="secondary" />,
        subItems: [
            {
                route: ACTIVITYTILIST,
                label: activityTimes,
                icon: <MoreTimeIcon color="secondary" />,
            },
            {
                route: ACTIVITYTIMESEXPORT,
                label: exportActivityTimes,
                icon: <FileDownloadOutlinedIcon color="secondary" />,
                permissions: [
                    'admin',
                    'export',
                    'Staff - Calidad y Experiencia',
                ],
            },
        ],
    },
    {
        label: commercialCrm,
        icon: <FingerprintOutlinedIcon color="secondary" />,
        permissions: ['admin', 'commercial crm'],
        subItems: [
            {
                route: COMMERCIAL_CRM_LOAD_BASE_BP,
                label: commercialCrmLoadBaseBP,
                icon: <SupportAgentIcon color="secondary" />,
            },
            {
                route: COMMERCIAL_CRM_LOAD_BASE_GUPSHUP,
                label: commercialCrmLoadBaseGupshup,
                icon: <WhatsAppIcon color="secondary" />,
            },
            {
                route: COMMERCIAL_CRM_LOAD_BASE_GUPSHUP_CUSTOM,
                label: commercialCrmLoadBaseGupshupCustom,
                icon: <WhatsAppIcon color="secondary" />,
            },
        ],
    },
    {
        label: cases,
        icon: <CasesOutlinedIcon color="secondary" />,
        permissions: ['admin', 'manager'],
        subItems: [
            {
                route: CASEMANAGEMENTLIST,
                label: caseManagement,
                icon: <WorkHistoryOutlinedIcon color="secondary" />,
                permissions: ['admin', 'manager'],
            },
            {
                route: CASEMANAGERBULKLOAD,
                label: bulkLoad,
                icon: <FileUploadOutlinedIcon color="secondary" />,
                permissions: ['admin', 'manager'],
            },
            {
                route: CASEMANAGERLIST,
                label: caseManager,
                icon: <ArticleOutlinedIcon color="secondary" />,
                permissions: ['admin', 'manager'],
            },
            {
                route: CASEREPORT,
                label: caseReport,
                icon: <AddToQueueOutlinedIcon color="secondary" />,
                permissions: ['admin', 'manager'],
            },
            {
                route: CASECLOSURE,
                label: caseClosure,
                icon: <WorkOffOutlinedIcon color="secondary" />,
                permissions: ['admin', 'manager'],
            },
            {
                route: CASECREATION,
                label: caseCreation,
                icon: <CreateNewFolderIcon color="secondary" />,
                permissions: ['admin', 'manager'],
            },
            {
                route: CASEOTRS,
                label: caseOTRS,
                icon: <EscalatorIcon color="secondary" />,
                permissions: ['admin', 'manager'],
            },
            {
                route: USERSCREATION,
                label: usersCreation,
                icon: <CreateNewFolderIcon color="secondary" />,
                permissions: ['admin', 'manager'],
            },
        ],
    },
    {
        route: WECALLYOUADMIN,
        label: weCallYouAdmin,
        icon: <PhoneCallbackOutlinedIcon color="secondary" />,
        permissions: ['admin'],
    },
    {
        route: SURVEYLIST,
        label: surveys,
        icon: <SubtitlesOutlinedIcon color="secondary" />,
        permissions: ['admin'],
    },
    {
        route: USERLIST,
        label: users,
        icon: <PeopleAltOutlinedIcon color="secondary" />,
        permissions: ['admin', 'user management'],
    },
    {
        route: BLOCKPAGES,
        label: blokPages,
        icon: <AppBlockingOutlinedIcon color="secondary" />,
        permissions: ['admin'],
    },
    {
        route: VOICE_BLASTER,
        label: voiceBlaster,
        icon: <CampaignIcon color="secondary" />,
        permissions: ['admin', 'voice admin'],
    },
    {
        route: IVR,
        label: ivr,
        icon: <PhoneInTalkIcon color="secondary" />,
        permissions: ['admin', 'voice admin'],
    },

    {
        route: IVR_TYPIFICATION_BASE,
        label: ivrTypificationBase,
        icon: <PhoneInTalkIcon color="secondary" />,
        permissions: ['admin'],
    },
];
